// The theme icon: sun or moon for what's showing now, opening the same
// Light / Dark / Match device choices as Settings → Appearance.
import { type ThemeChoice, useSystemDark, useTheme } from '@/app/theme';
import { t } from '@/l10n/strings';
import { IconButton } from '@/ui/controls';
import { Icon, type IconName } from '@/ui/Icon';
import { Menu } from '@/ui/Menu';

const CHOICES: { id: ThemeChoice; icon: IconName; label: () => string }[] = [
  { id: 'system', icon: 'layout', label: () => t('webThemeSystem') },
  { id: 'light', icon: 'sun', label: () => t('themeLight') },
  { id: 'dark', icon: 'moon', label: () => t('themeDark') },
];

export function ThemeButton({ placement }: { placement: 'up' | 'down' }) {
  const [theme, setTheme] = useTheme();
  const systemDark = useSystemDark();
  const showingDark = theme === 'dark' || (theme === 'system' && systemDark);
  const icon: IconName = showingDark ? 'moon' : 'sun';
  return (
    <div className={placement === 'up' ? 'theme-menu theme-menu--sidebar' : 'theme-menu'}>
      <Menu
        placement={placement}
        fixed={placement === 'up'}
        trigger={(props) =>
          placement === 'up' ? (
            <button type="button" className="sidebar__item" aria-label={t('commonTheme')} title={t('commonTheme')} {...props}>
              <Icon name={icon} size={19} />
              <span>{t('commonTheme')}</span>
            </button>
          ) : (
            <IconButton icon={icon} label={t('commonTheme')} {...props} />
          )
        }
      >
        {(close) =>
          CHOICES.map((choice) => (
            <button
              key={choice.id}
              role="menuitemradio"
              type="button"
              className="menu__item"
              aria-checked={theme === choice.id}
              onClick={() => {
                setTheme(choice.id);
                close();
              }}
            >
              <Icon name={choice.icon} size={18} />
              <span className="grow">{choice.label()}</span>
              {theme === choice.id && <Icon name="check" size={16} />}
            </button>
          ))
        }
      </Menu>
    </div>
  );
}
